import React from 'react';
import { useStore } from '@/context/StoreContext';
import { QuoteDialog } from '@/components/QuoteDialog';
import { Seo } from '@/components/Seo';
import { Ship, PackageCheck, FileCheck2, Globe2 } from 'lucide-react';

const HERO = '/images/categories/spirits.jpg';

export default function ImportExport() {
  const { lang } = useStore();
  const fr = lang === 'fr';
  const services = [
    { icon: Globe2, title: fr ? 'Sourcing International' : 'International Sourcing', body: fr ? 'Acc\u00e8s privil\u00e9gi\u00e9 aux domaines, n\u00e9gociants et caves priv\u00e9es du monde entier.' : 'Privileged access to estates, merchants and private cellars worldwide.' },
    { icon: FileCheck2, title: fr ? 'Douanes & Conformit\u00e9' : 'Customs & Compliance', body: fr ? 'Gestion compl\u00e8te des formalit\u00e9s douani\u00e8res, accises et documentation.' : 'End-to-end handling of customs, excise and documentation.' },
    { icon: PackageCheck, title: fr ? 'Entreposage sous Douane' : 'Bonded Warehousing', body: fr ? 'Stockage professionnel sous temp\u00e9rature contr\u00f4l\u00e9e et sous douane.' : 'Professional, temperature-controlled bonded storage.' },
    { icon: Ship, title: fr ? 'Logistique Mondiale' : 'Global Logistics', body: fr ? 'Transport assur\u00e9 porte-\u00e0-porte, avec suivi et emballage sp\u00e9cialis\u00e9.' : 'Insured door-to-door transport, tracked and specially packaged.' },
  ];
  return (
    <div className="bg-nw-black">
      <Seo title={fr ? 'Import & Export de vins et spiritueux' : 'Wine & Spirits Import & Export Services'} description={fr ? 'Sourcing international, douanes, entreposage sous douane et logistique assur\u00e9e pour professionnels, importateurs et maisons de prestige.' : 'International sourcing, customs, bonded warehousing and insured logistics for professionals, importers and prestige houses.'} path="/import-export" lang={lang} />
      <section className="relative h-[46vh] flex items-center overflow-hidden nw-vignette">
        <img src={HERO} alt={fr ? 'Spiritueux d\u2019exception en cave' : 'Exceptional spirits in the cellar'} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-nw-black/72" />
        <div className="relative nw-container w-full">
          <div className="max-w-xl">
            <div className="nw-eyebrow text-nw-gold mb-3">B2B</div>
            <h1 className="font-serif text-4xl sm:text-6xl text-nw-ivory leading-tight">Import &amp; Export</h1>
            <p className="mt-4 text-nw-warmgrey text-sm leading-relaxed">{fr ? 'Un partenaire discret et fiable pour les professionnels, importateurs et maisons de prestige.' : 'A discreet, reliable partner for professionals, importers and prestige houses.'}</p>
          </div>
        </div>
      </section>
      <section className="nw-container py-16 lg:py-24">
        <div className="grid sm:grid-cols-2 gap-6">
          {services.map((s, i) => (
            <div key={i} className="flex gap-5 border border-nw-gold/15 bg-nw-espresso p-7">
              <s.icon className="text-nw-gold shrink-0" size={30} strokeWidth={1} />
              <div>
                <h2 className="font-serif text-xl text-nw-ivory">{s.title}</h2>
                <p className="text-sm text-nw-warmgrey mt-2 leading-relaxed">{s.body}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-16 border border-nw-gold/25 bg-nw-espresso p-10 text-center">
          <h2 className="font-serif text-3xl text-nw-ivory">{fr ? 'Discutons de votre projet' : 'Let us discuss your project'}</h2>
          <p className="mt-3 text-nw-warmgrey text-sm max-w-xl mx-auto">{fr ? 'Import, export, sourcing de bouteilles rares ou partenariat \u2014 notre \u00e9quipe corporate vous r\u00e9pond sous un jour ouvr\u00e9.' : 'Import, export, rare bottle sourcing or partnership \u2014 our corporate team responds within one business day.'}</p>
          <div className="mt-6 flex flex-wrap justify-center gap-4">
            <QuoteDialog defaultType="import" source="import_export_page" trigger={<button data-testid="import-enquiry-button" className="nw-btn-gold">{fr ? 'Demande Import' : 'Import Enquiry'}</button>} />
            <QuoteDialog defaultType="export" source="import_export_page" trigger={<button data-testid="export-enquiry-button" className="nw-btn-ivory">{fr ? 'Demande Export' : 'Export Enquiry'}</button>} />
          </div>
        </div>
      </section>
    </div>
  );
}
